'use strict';

var cors = require('./cors');
var debug = require('./debug');
var object = require('./object');
var date = require('./date');
var prefixedCookies = require('./cookies')('_hcfnl_');
var frontendVersion = require('./frontendversion')();


var Transport = function(url) {
  this.url = url;
};

Transport.isQueuedMode = true;
Transport.urlPrefix = '//ostrovok.ru/hc';
Transport.req_id = 0;
Transport.ver = BUILD_REF;
Transport.frontendVersion = frontendVersion.version;
Transport.verbose = VERBOSE;

Transport.queue = [];
Transport.online = true;


Transport.disableQueuedMode = function() {
  Transport.isQueuedMode = false;
};

Transport.setUrlPrefix = function(prefix) {
  debug.log('[transport] url prefix', prefix);
  Transport.urlPrefix = prefix;
};

Transport.onlineStatusChanged = function(event) {
  var online = !!navigator.onLine;

  Transport.online = online;

  if (online) {
    Transport.dequeue();
  };

  debug.log('[transport online status]', online);
};

window.addEventListener('online',  Transport.onlineStatusChanged, false);
window.addEventListener('offline', Transport.onlineStatusChanged, false);

Transport.enqueue = function(url, query, post) {
  Transport.queue.push([url, query, post]);

  debug.log('[transport request enqueued]', [url, query, post], Transport.queue.length, Transport.online);
};

Transport.dequeue = function() {
  debug.log('[transport dequeue]', Transport.queue);

  while (Transport.queue.length) {
    var request = Transport.queue.shift();

    Transport.request(request[0], request[1], request[2]);
  }
};

Transport.request = function(url, query, post) {
  var beacon = navigator.sendBeacon && query.beacon === true;

  if (debug.isEnabled()) {
    debug.log('[transport]', url, query, post);
  } else if (beacon) {
    cors.send('beacon_post', url, JSON.stringify(post));
  } else if (post) {
    cors.send('post', url, JSON.stringify(post));
  } else {
    var img = new Image();
    img.src = url;
  }
};

Transport.prototype.setVerbose = function(enable) {
  Transport.verbose = !!enable;

  debug.log('[funnel] transport verbose-mode is ' + (Transport.verbose ? 'on' : 'off'));
};

Transport.prototype.encode = function(data) {
  var arr = [];

  for (var name in data) {
    var value = name + '=';
    if (!data.hasOwnProperty(name)) {
      continue;
    }

    var type = typeof data[name];

    if (type == 'boolean') {
      value += (data[name] ? '1' : '0');
    }
    // null, undefined, 'null', 'undefined'
    else if (type == 'undefined' || data[name] == null || data[name] === '' || data[name] === 'null' || data[name] === 'undefined' ) {
      continue;
    }
    else if (type == 'object') {
      value += encodeURIComponent(JSON.stringify(data[name]));
    }
    else {
      value += encodeURIComponent(data[name]);
    }

    arr.push(value);
  }

  return arr;
};

Transport.prototype.send = function(queryData, opt_postData) {
  var now = new Date();

  ++Transport.req_id;

  var post = null;
  if (opt_postData !== null && typeof opt_postData === 'object' && Object.keys(opt_postData).length !== 0) {
    post = opt_postData;
  }

  var query = queryData || {};

  if (post && !cors.hasSupport()) {
    query = object.assign({}, queryData, post);
    post = null;
  }

  var queryString = ''
    + '?req_id=' + Transport.req_id
    + '&ver=' + Transport.ver
    + '&fpr=' + prefixedCookies.get('fpr')
    + '&ota_http_request_id=' + (window.ota_http_request_id || '')
    + '&frontend_version=' + Transport.frontendVersion
    + '&timesend=' + now.valueOf()
    + '&user_time=' + encodeURIComponent(date.toLocalISOString(now))
    + (query ? '&' + this.encode(query).join('&') : '')
    // mark all requests from queue,
    // because it may contains sideeffects
    + (Transport.isQueuedMode ? '&_from_queue=1' : '')
    + (!Transport.online ? '&_from_offline_queue=1' : '')
    + (Transport.verbose ? '&verbose=1' : '');

  var url = Transport.urlPrefix + this.url + queryString;

  this.pushToDataLayer(query);

  if (Transport.online) {
    Transport.request(url, query, post);
  } else {
    Transport.enqueue(url, query, post);
  }
};

Transport.prototype.pushToDataLayer = function(data) {
  var endpoint = this.url.substring(1);
  var event;

  if (endpoint === 'funnel_v2') {
    event = {event: 'funnel.hit'};
  } else if (endpoint === 'event') {
    event = {event: 'funnel.event'};
  } else {
    return;
  }

  event['funnel.context'] = data;

  var dataLayer = (window.dataLayer = window.dataLayer || []);

  dataLayer.push(event);

  debug.log('[funnel] transport push to dataLayer', event);
}

module.exports = Transport;



//////////////////
// WEBPACK FOOTER
// ./lib/transport.js
// module id = 5
// module chunks = 1 3